<template>
<div class="profile-left">
  <h1 class="company-profile-title">Профиль</h1>

  <div class="head-profile head-profile-skeleton">
    <div class="sk-avatar shimmer"></div>

    <div class="sk-name shimmer"></div>
    <div class="sk-specifics shimmer"></div>

    <div class="sk-actions">
      <div class="sk-button sk-button-main shimmer"></div>
      <div class="sk-button sk-button-side shimmer"></div>
    </div>
  </div>

  <div class="basic-profile basic-profile-skeleton">
    <div class="sk-line sk-line-location shimmer"></div>

    <div class="sk-tags">
      <div class="sk-tag shimmer"></div>
      <div class="sk-tag shimmer"></div>
      <div class="sk-tag shimmer"></div>
    </div>

    <div class="sk-section">
      <div class="sk-label shimmer"></div>
      <div class="sk-value shimmer"></div>
    </div>

    <div class="sk-section">
      <div class="sk-label shimmer"></div>
      <div class="sk-value short shimmer"></div>
    </div>

    <div class="sk-section">
      <div class="sk-label shimmer"></div>
      <div class="sk-value shimmer"></div>
    </div>

    <div class="sk-section">
      <div class="sk-label shimmer"></div>
      <div class="sk-value wide shimmer"></div>
    </div>
  </div>

  <div class="company-social-media-left social-skeleton">
    <div class="sk-social-title shimmer"></div>
    <div class="sk-social-row">
      <div class="sk-social-icon shimmer"></div>
      <div class="sk-social-icon shimmer"></div>
      <div class="sk-social-icon shimmer"></div>
      <div class="sk-social-icon shimmer"></div>
      <div class="sk-social-icon shimmer"></div>
    </div>
  </div>
</div>

<div class="user-scroll-panel">
  <div class="scrollable-column">
    <div class="sk-right-title shimmer"></div>
    <div class="sk-company-card shimmer"></div>

    <div class="sk-right-title shimmer"></div>
    <div class="sk-info-card shimmer"></div>

    <div class="sk-right-title shimmer"></div>
    <div class="sk-info-card shimmer"></div>
  </div>
</div>
</template>

<style scoped>
.profile-left {
  width: 750px;
  padding: 20px;
  margin-left: calc(50% - 550px);
  box-sizing: border-box;
}

.company-profile-title {
  font-size: 17px;
  font-family: "Eastman-Bold", sans-serif;
  margin-left: calc(50% - 370px);
  margin-top: 10px;
  color: var(--text);
}

.head-profile {
  width: 700px;
  margin-bottom: 8px;
  padding: 28px 0 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  box-sizing: border-box;
}

.basic-profile {
  width: 700px;
  min-height: 430px;
  background: var(--card-bg, #fff);
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 30px;
  box-sizing: border-box;
}

[data-theme="dark"] .basic-profile {
  background: #1f1f1f;
  border-color: rgba(255, 255, 255, 0.08);
}

.user-scroll-panel {
  position: absolute;
  top: 0;
  left: calc(50% + 200px);
  width: 340px;
  padding: 16px 12px;
  z-index: 2;
  box-sizing: border-box;
}

.scrollable-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.shimmer {
  position: relative;
  overflow: hidden;
  background: #e2e2e2;
}

[data-theme="dark"] .shimmer {
  background: #2b2b2b;
}

.shimmer::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.42),
    transparent
  );
  animation: profileShimmer 1.4s infinite;
}

[data-theme="dark"] .shimmer::after {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.08),
    transparent
  );
}

.sk-avatar {
  width: 166px;
  height: 166px;
  border-radius: 50%;
}

.sk-name {
  width: 260px;
  height: 28px;
  border-radius: 999px;
  margin-top: 26px;
}

.sk-specifics {
  width: 360px;
  height: 18px;
  border-radius: 999px;
  margin-top: 12px;
}

.sk-actions {
  width: 100%;
  margin-top: 14px;
  display: grid;
  grid-template-columns: 1.9fr 1fr;
  gap: 18px;
}

.sk-button {
  height: 44px;
  border-radius: 10px;
}

.sk-line-location {
  width: 260px;
  height: 20px;
  border-radius: 999px;
  margin-bottom: 34px;
}

.sk-tags {
  display: flex;
  gap: 8px;
  margin-bottom: 34px;
}

.sk-tag {
  width: 90px;
  height: 28px;
  border-radius: 999px;
}

.sk-section {
  margin-bottom: 32px;
}

.sk-label {
  width: 90px;
  height: 12px;
  border-radius: 999px;
  margin-bottom: 10px;
}

.sk-value {
  width: 280px;
  height: 16px;
  border-radius: 999px;
}

.sk-value.short {
  width: 110px;
}

.sk-value.wide {
  width: 520px;
  max-width: 100%;
}

.company-social-media-left {
  margin-top: 40px;
  width: 700px;
  background: var(--card-bg, #fff);
  border-radius: 15px;
  padding: 26px 30px;
  box-sizing: border-box;
}

[data-theme="dark"] .company-social-media-left {
  background: #1f1f1f;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.sk-social-title {
  width: 130px;
  height: 18px;
  border-radius: 999px;
}

.sk-social-row {
  display: flex;
  gap: 24px;
  margin-top: 28px;
}

.sk-social-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

.sk-right-title {
  width: 160px;
  height: 18px;
  border-radius: 999px;
}

.sk-company-card {
  width: 100%;
  height: 260px;
  border-radius: 16px;
}

.sk-info-card {
  width: 100%;
  height: 170px;
  border-radius: 16px;
}

@keyframes profileShimmer {
  100% {
    transform: translateX(100%);
  }
}

@media (max-width: 430px) {
  .profile-left {
    width: 100%;
    margin-left: 0;
    padding: 10px;
  }

  .company-profile-title {
    margin-left: 10px;
  }

  .head-profile,
  .basic-profile,
  .company-social-media-left {
    width: 100%;
  }

  .user-scroll-panel {
    position: relative;
    left: auto;
    width: 100%;
    padding: 12px 10px 100px;
  }

  .sk-actions {
    grid-template-columns: 1fr;
  }
}
</style>